<template>
  <div class="shipment-detail">
    <div class="top-info">
      选择合作中的采购商：
      <el-select v-model="distributorCompanyId" filterable placeholder="请选择分销商" @change="distributorChange">
        <el-option
          v-for="item in distributionList"
          :key="item.distributorCompanyId"
          :label="item.distributorCompanyName"
          :value="item.distributorCompanyId"
        ></el-option>
      </el-select>

      <span class="distributor-rank" v-if="distributorInfo.distributorLevel">{{ distributorInfo.distributorLevel }} 级分销</span>
      <el-popover placement="right" width="400" trigger="click" @show="getContactPersonInfo">
        <div>
          <p>联系人：{{ contactInfo.contactName }}</p>
          <p>
            手机：{{ contactInfo.contactPhone }}
            <template v-if="contactInfo.contactPhone">
              <el-button type="link" class="ml_10" @click="getContactPersonInfo(true)">查看</el-button>
              <el-button type="link" class="ml_10" @click="$event => copyCode(contactInfo.contactPhone, $event)">复制</el-button>
            </template>
          </p>
          <!-- <p>微信：{{ `` }} <el-button type="link" class="ml_10" @click="$event => copyCode('123243243', $event)">复制</el-button></p> -->
        </div>
        <el-button slot="reference" type="link" class="ml_10">联系方式</el-button>
      </el-popover>
      <el-button type="primary" class="mr_10 fr" @click="goPage('/supplier/dangkou/shipment')">查看所有待拿货采购商</el-button>
    </div>
    <div class="total">
      <div class="left">
        <span v-for="item in amountList" :key="item.key" class="item">
          <span>{{ item.text }}:</span>
          <span class="num">
            <span v-if="!takenOrderInfoVo[item.key]"> - </span>
            <AmountDigitText v-else-if="['notTakenTotalAmount', 'notReturnTotalAmount'].includes(item.key)" :value="takenOrderInfoVo[item.key] * (item.multiple || 1)"/>
            <span v-else>{{ (takenOrderInfoVo[item.key] * (item.multiple || 1)).toFixed(item.toFixed || 0) }}</span>
          </span>
        </span>
      </div>
      <div class="right">
        最近拿货时间： <span class="update-time"> {{ takenOrderInfoVo.lastTakenTime || '-' }}</span>
        <span style="margin-left: 15px">近90天拿货次数：{{ takenOrderInfoVo.recentlyTakenQuantity || '-' }}</span>
      </div>
    </div>
    <el-form :inline="true" :model="searchForm" class="search-form" style="margin-top: 10px">
      <template v-for="searchItem in searchList">
        <el-form-item :key="searchItem.prop">
          <component
            :is="'search-' + searchItem.type"
            :items="searchItem.items"
            v-model="searchForm[searchItem.prop]"
            @search="search"
            :attrs="searchItem.attrs"
          />
        </el-form-item>
      </template>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="clear">清空</el-button>
      </el-form-item>
    </el-form>
    <TableTopBtns :btns="btnList" @click="topBtnsClick" />
    <div class="content">
      <TableList
        ref="table"
        :cols="cols"
        :list="list"
        selection
        selectionFixed="left"
        @selection-change="selectionChange"
        :height="tableHeight"
      >
        <template slot="picPathSlot" slot-scope="{ row }">
          <div style="display: flex; align-items: center">
            <ListLazyImg :size="{ width: 40, height: 40 }" :src="`${row.picPath}`" />
          </div>
        </template>

        <template slot="notTakenAmountSlot" slot-scope="{ row }">
          {{ formatNumberWithCommas(((row.notTakenAmount || 0) / 100).toFixed(amountDigit)) }}
        </template>
        <!--
        <template slot="numSlot" slot-scope="{ row }">
          {{ row.printTagQuantity || 0 }} / {{ row.notTakenQuantity }}
          <el-button type="link" class="ml_10" @click="printDetailDialog(row)"
            >{{ row.printTagQuantity }} / {{ row.notTakenAmount }}</el-button
          >
        </template>
        -->
        <template slot="titleSlot" slot-scope="{ row }">
          <el-tooltip v-if="!row.matchSupplierItem" class="item" effect="dark" content="未匹配ERP商品/规格" placement="bottom">
            <el-tag color="#82318a" class="tag-label" type="success" effect="dark" size="mini">匹</el-tag>
          </el-tooltip>
          <el-tooltip effect="dark" :content="row.title" placement="bottom">
            <span class="overflow-text" style="width: 160px">{{ row.title }}</span>
          </el-tooltip>
        </template>
        <template slot="purchasePriceSlot" slot-scope="{ row }">
          <el-tooltip v-if="!row.isApproval" class="item" effect="dark" content="供货价审核中" placement="bottom">
            <el-tag color="#f28302" class="tag-label" type="success" effect="dark" size="mini">审</el-tag>
          </el-tooltip>
          {{ getPurchasePrices(row) }}
        </template>
        <template slot="opcolsSlot" slot-scope="{ row }">
          <el-button v-if="!row.matchSupplierItem" type="link" @click="matchErp(row)">匹配ERP商品</el-button>
          <el-button type="link" @click="editPrice([row])">改供货价</el-button>
          <el-button type="link" @click="editLog(row)">改价记录</el-button>
        </template>
      </TableList>
      <el-row style="margin-top: 10px" type="flex" justify="end">
        <Pagination :limit.sync="pageData.pageSize" :page.sync="pageData.pageNo" :total="pageData.total" @pagination="getList" />
      </el-row>
    </div>
    <PrintDetailDialog ref="printDetailDialogRef"></PrintDetailDialog>
    <EditPriceDialog ref="editPriceDialogRef"></EditPriceDialog>
    <EditPriceLogDialog ref="editPriceLogDialogRef"></EditPriceLogDialog>
    <ChooseProdDialog ref="chooseProdDialogRef"></ChooseProdDialog>
  </div>
</template>

<script>
import SearchSelect from '@/components/prod/center/components/SearchSelect.vue';
import SearchInput from '@/components/prod/center/components/SearchInput.vue';
import TableTopBtns from '@/components/prod/center/TableTopBtns.vue';
import TableList from '@/components/TableList.vue';
import Pagination from '@/components/pagination.vue';
import ListLazyImg from '@/components/ListLazyImg/index.vue';
import PrintDetailDialog from './components/printDetailDialog/index.vue';
import EditPriceDialog from './components/editPriceDialog.vue';
import EditPriceLogDialog from './components/editPriceLogDialog/index.vue';
import ChooseProdDialog from './components/chooseProdDialog.vue';

import { amountList, searchList, colList, btnList } from './dictionary';
import { logoutServer } from '@/pages/login/servers.js';
import tableMixins from '@mixins/table-mixins';

import dayjs from 'dayjs';

import {
  getTakenOrderInfo,
  getTakenOrderDetailList,
  mateErpGoods,
  getContactDetailInfo,
  getPurchaserPageList,
  getChangePriceCount,
  getPurchaseConfig,
} from '@servers/dangkou/index.js';

import _, { get } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  components: {
    SearchSelect,
    SearchInput,
    TableList,
    Pagination,
    TableTopBtns,
    ListLazyImg,
    PrintDetailDialog,
    EditPriceDialog,
    EditPriceLogDialog,
    ChooseProdDialog,
  },
  mixins: [new tableMixins(230)],
  data() {
    const defaultSearchForm = {
      isSkuMatched: '', // 商品是否匹配 1-是，0-否
      isApproval: '', // 拿货价是否待审核 0：是 1：否
      outerIdList: '', // 款式编码
      itemOuterIdList: '', // 商品编码
      text: '',
    };
    return {
      takenOrderInfoVo: {},
      distributorInfo: {},
      distributionList: [],
      distribution: {},
      amountList,
      btnList,
      isLogin: true,
      distributorCompanyId: '',
      defaultSearchForm: _.cloneDeep(defaultSearchForm),
      searchForm: _.cloneDeep(defaultSearchForm),
      pageData: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      searchList,
      list: [],
      cols: colList,
      selectRows: [],
      contactInfo: {},
      from: false,
    };
  },
  computed: {
    ...mapGetters(['amountDigit']),
  },
  watch: {
    $route: {
      handler(val) {
        let distributorCompanyId = get(val, 'params.distributorCompanyId', '') || get(val, 'query.distributorCompanyId', '');
        let from = get(val, 'query.from', '');
        if (!distributorCompanyId) return;
        this.distributorCompanyId = Number(distributorCompanyId);
        this.from = from;
        this.init();
        let userInfo = this.$store.getters?.userInfo;
        if (userInfo) {
          window.parent.postMessage({ data: userInfo, eventName: 'userInfo' }, '*');
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage, false);
  },
  methods: {
    async init() {
      await this.getDistributorPageList();
      if (!this.distributionList.length) return;
      if (!this.distributionList.find(item => item.distributorCompanyId == this.distributorCompanyId)) {
        this.distributorCompanyId = this.distributionList[0].distributorCompanyId;
      }
      this.getTakenOrderInfo();
      this.getList();
    },
    // 查找数据
    async getTakenOrderInfo() {
      const data = await getTakenOrderInfo({ distributorCompanyId: this.distributorCompanyId });
      this.takenOrderInfoVo = data.takenOrderInfoVo || {};
      this.distributorInfo = data.distributorInfo || {};
    },
    async getList() {
      let params = {
        ...this.searchForm,
        distributorCompanyId: this.distributorCompanyId,
        outerIdList: this.searchForm.outerIdList ? this.searchForm.outerIdList.split(',') : [],
        itemOuterIdList: this.searchForm.itemOuterIdList ? this.searchForm.itemOuterIdList.split(',') : [],
        pageNo: this.pageData.pageNo,
        pageSize: this.pageData.pageSize,
      };
      const data = await getTakenOrderDetailList(params);
      const { list = [], total = 0 } = data || {};
      this.list = list;
      this.pageData.total = total;
    },
    async getDistributorPageList() {
      const { list } = await getPurchaserPageList(
        {
          pageNo: 1,
          pageSize: 300,
        },
        { isNeedLoading: false }
      );
      this.distributionList = (list || []).map(item => {
        return {
          distributorCompanyId: item.distributorCompanyId,
          distributorCompanyName: item.distributorCompanyName,
          distributorLevel: item.distributorLevel,
        };
      });
    },
    distributorChange() {
      this.getTakenOrderInfo();
      this.getList();
    },
    search() {
      this.pageData.pageNo = 1;
      this.getList();
    },
    clear() {
      this.pageData.pageNo = 1;
      this.searchForm = _.cloneDeep(this.defaultSearchForm);
      this.search();
    },
    printDetailDialog(row) {
      this.$refs.printDetailDialogRef.openDialog({});
    },
    getPurchasePrices(row) {
      return Array.from(new Set(row.purchasePriceList || []))
        .map(val => (val / 100).toFixed(this.amountDigit))
        .join(',');
    },
    matchErp(row) {
      this.$refs.chooseProdDialogRef.openDialog({
        sureFn: async item => {
          const params = {
            distributorCompanyId: this.distributorCompanyId,
            supplierCompanyId: row.supplierCompanyId || this.$store.getters.userInfo.companyId,
            distributorErpSysItemId: row.sysItemId,
            distributorErpSysSkuId: row.sysSkuId,
            supplierErpSysItemId: item.sysItemId,
            supplierErpSysSkuId: item.sysSkuId,
          };
          const res = await mateErpGoods(params);
          if (res) {
            this.getList();
            this.$message.success(`采购商品匹配成功`);
          }
        },
      });
    },
    async editPrice(rows, isBatch) {
      if (rows.length === 1) {
        const row = rows[0];
        const params = {
          distributorCompanyId: this.distributorCompanyId,
          sysItemId: row.sysItemId,
          sysSkuId: row.sysSkuId,
          approvalStatusList: [0, 1],
          queryTimeType: 0,
          startTime: dayjs().startOf('day').valueOf(),
          endTime: dayjs().endOf('day').valueOf(),
        };
        const count = await getChangePriceCount(params);
        const config = await getPurchaseConfig({ companyId: this.distributorCompanyId });
        const { frequencyLimit = 0 } = config.priceChangeApprovalConfig || {};
        if (count >= frequencyLimit) {
          this.$message.error('已超出今日供应商改价次数限制！请明日再试或者联系管理员修改配置！');
          return;
        }
      }
      this.$refs.editPriceDialogRef.openDialog(rows, {
        title: isBatch ? '批量改供货价' : '改供货价',
        distributorCompanyId: this.distributorCompanyId,
        successFn: this.getList,
      });
    },
    editLog(row) {
      this.$refs.editPriceLogDialogRef.openDialog(row, this.distributorCompanyId);
    },
    topBtnsClick(eventName) {
      if (eventName === 'batchEditPrice') {
        if (!this.selectRows.length) {
          this.$message.success(`请先选择商品再进行操作！`);
          return;
        }
        this.editPrice(this.selectRows, true);
      }
    },
    selectionChange(selection) {
      this.selectRows = selection;
    },
    async getContactPersonInfo(isDecode = false) {
      this.contactInfo = await getContactDetailInfo({ distributorCompanyId: this.distributorCompanyId, decode: isDecode });
    },
    goPage(href) {
      // location.href = href;
      window.open(href, '_blank');
    },
    receiveMessage(event) {
      const { data = {}, eventName } = event.data;
      if (eventName === 'logout') {
        this.logout();
      }
    },
    async logout() {
      try {
        const success = await logoutServer();
        if (success) {
          window.localStorage.removeItem('userinfo');
          this.$router.push({
            name: 'l_index',
            params: {
              userName: this.account,
              companyName: this.companyName,
            },
          });
          this.$store.dispatch('resetNavTabs');
        }
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * 查看
     */
    viewCode(text, e) {},
    /**
     * 复制
     */
    copyCode(text, e) {
      this.$copyText(text).then(
        e => {
          this.$message.success(`复制成功`);
        },
        e => {
          this.$message.error(e.message);
        }
      );
    },
    formatNumberWithCommas(num) {
      let numParts = num.toString().split('.');
      numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return numParts.join('.');
    },
  },
};
</script>

<style lang="scss" scoped>
.shipment-detail {
  padding: 15px;
  .ml_10 {
    margin-left: 10px;
  }
  .mr_10 {
    margin-right: 10px;
  }
  .fr {
    float: right;
  }
  .el-form-item {
    margin: 0px 4px 6px 0px;
  }
  .distributor-rank {
    margin-left: 10px;
    padding: 1px 6px;
    background-color: #f8b866;
    color: #fff;
  }
  .tag-label {
    height: 18px;
    line-height: 18px;
    padding: 0px 2px;
    border-color: #fff;
  }
  .total {
    height: 40px;
    line-height: 40px;
    .left {
      float: left;
      .item {
        padding: 0px 10px;
      }
    }
    .num {
      color: #ff9149;
      font-size: 14px;
      font-weight: 600;
    }
    .right {
      float: right;
      margin-right: 20px;
    }
  }
  .overflow-text {
    // width: 200px; /* 设置容器的宽度 */
    display: inline-block;
    vertical-align: top;
    white-space: nowrap; /* 防止文字换行 */
    overflow: hidden; /* 隐藏溢出的文字 */
    text-overflow: ellipsis; /* 将溢出的文字显示为省略号 */
  }
}
</style>
